import { ChangeEvent } from 'react'

import { Box, List, NumberBadge, Table, Text } from '@factorialco/deprecated-design-system'
import { BookkeeperCustomerFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import Body from './Body'
import Header from './Header'
import Searchbar from './Searchbar'

interface Props {
  customers: BookkeeperCustomerFragment[]
  search: string
  setSelectedCustomer: (customer: BookkeeperCustomerFragment | null) => void
  onSearch: (search: ChangeEvent<HTMLInputElement>) => void
}

const CompaniesTable = ({ customers, search, setSelectedCustomer, onSearch }: Props) => {
  return (
    <Box width="full" gap="s16">
      <Box flexDirection="row" gap="s8" alignItems="center">
        <Text weight="semibold" size="400">
          {i18n.t('bookkeepers.companies.title')}
        </Text>
        <NumberBadge label={customers.length} color="grey400" textColor="grey800" />
      </Box>
      <List>
        <Box
          width="full"
          flexDirection="row"
          background="grey200"
          alignItems="center"
          paddingX="s32"
          paddingY="s6"
          gap="s12"
        >
          <Box width="full">
            <Searchbar search={search} onSearch={onSearch} />
          </Box>
        </Box>
        <Table
          density="compact"
          autoLayout
          fullWidth
          noTopRadius
          hideBorder
          background="grey000White"
        >
          <Header />
          <Body customers={customers} setSelectedCustomer={setSelectedCustomer} />
        </Table>
      </List>
    </Box>
  )
}

export default CompaniesTable
